import { render, staticRenderFns } from "./CampaignStatsTotalModal.vue?vue&type=template&id=8ea5c79a&scoped=true&"
import script from "./CampaignStatsTotalModal.vue?vue&type=script&lang=js&"
export * from "./CampaignStatsTotalModal.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStatsTotalModal.vue?vue&type=style&index=0&id=8ea5c79a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea5c79a",
  null
  
)

export default component.exports